module.exports = __webpack_public_path__ + "static/media/my_family_doctor_p1_1.28d7003a.png";